import AccountPreview from "./AccountPreview"
import OBAccountPreview from "./OBAccountPreview"
import { formatCurrency } from "../../utilities/general-utils"
import styles from "./AccountGroup.module.css"

const AccountGroup = ({ showIncludedAccounts, group, title }) => {
    if (!group || group.accounts.length === 0) return null
    return (
        <div className={styles.accountGroup}>
            <h3 className={styles.accountGroupHeading}>
                <span className={styles.accountGroupTitle}>{title}</span>
                <span className={styles.accountGroupBalance}>{formatCurrency(group.balance)}</span>
            </h3>
            {group.accounts
                .filter(account => {
                    if (showIncludedAccounts) {
                        return account.includeBalance === 1
                    }
                    return true
                })
                .map(account => {
                    return account.hasOwnProperty("obCustomerId")
                        ? <OBAccountPreview account={account} key={account.id + account.data.name} />
                        : <AccountPreview account={account} key={account.id + account.name} />
                })
            }
        </div>
    )
}

export default AccountGroup